import styled from 'styled-components';

import { HighCostMedRowMenuProps } from 'components/shared/highCostMeds/highCostMedListColumns';
import Menu from 'components/shared/menu';
import { useProfile } from 'context/profile';
import { PERMISSIONS } from 'models/Profile';
import { colors } from 'styles/theme/colors';
import PencilIconOutline from 'svg/PencilIconOutline';
import ThreeDotMenu from 'svg/ThreeDotMenu';
import TrashIcon from 'svg/TrashIcon';

// Gated the same way the admin row menu is, off the customer permission names rather than the admin
// ones: one name per action, so edit and delete are checked separately. See design 003,
// "Authorization".
export default function HighCostMedsRowMenu({ highCostMedicationListItem, onEdit, onRemove }: HighCostMedRowMenuProps) {
  const { profile } = useProfile();

  const canEdit = profile.has(PERMISSIONS.highCostMedicationListItemEdit);
  const canDelete = profile.has(PERMISSIONS.highCostMedicationListItemDelete);

  // A view-only user gets no actions menu at all rather than an empty one.
  if (!canEdit && !canDelete) return null;

  return (
    <Menu $size='small'>
      <Menu.Trigger>
        <KebabButton type='button' aria-label='Row actions'>
          <ThreeDotMenu />
        </KebabButton>
      </Menu.Trigger>
      <Menu.Content position='right'>
        {canEdit && (
          <Menu.Item onClick={() => onEdit(highCostMedicationListItem)}>
            <PencilIconOutline width={14} height={14} />
            Edit details
          </Menu.Item>
        )}
        {canEdit && canDelete && <Menu.Divider />}
        {canDelete && (
          <RemoveItem onClick={() => onRemove(highCostMedicationListItem)}>
            <TrashIcon width={14} height={14} color={colors.red100} />
            Remove
          </RemoveItem>
        )}
      </Menu.Content>
    </Menu>
  );
}

const KebabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const RemoveItem = styled(Menu.Item)`
  color: ${({ theme }) => theme.colors.red100};
`;
